import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export const sendSetupLink = async (email: string) => {
  const response = await authAPI.get(`/activation/resend/${encodeURIComponent(email)}`)
  return response.data
}

export const useSendSetupLink = () => useMutation({ mutationFn: sendSetupLink })
